import { useState } from 'react';
import { ExternalLink, Gift, Star } from 'lucide-react';
import { GIFT_COPY } from '@garlic/shared';
import { cx } from '../../ui/primitives';

/**
 * Convite do brinde (texto em GIFT_COPY). Aparece no comprovante de saída e também para quem pagou só a sua
 * parte pelo celular. O sistema só registra o clique (quando há comprovante), não verifica avaliação.
 */
export function GiftCard({ reviewUrl, thanksText, initiallyClicked = false, onReviewClick, className }: {
  reviewUrl: string | null;
  thanksText: string;
  initiallyClicked?: boolean;
  onReviewClick?: () => void;
  className?: string;
}) {
  const [clicked, setClicked] = useState(false);
  const thanks = clicked || initiallyClicked;
  return (
    <section className={cx('overflow-hidden rounded-3xl border-2 border-[var(--brand)] bg-white text-center shadow-card', className)}>
      <div className="bg-[color-mix(in_srgb,var(--brand)_10%,white)] px-6 py-6">
        <Gift className="mx-auto size-10 text-[var(--brand)]" />
        <h2 className="mt-2 font-display text-2xl font-bold tracking-tight">{GIFT_COPY.title}</h2>
        {reviewUrl ? (
          <>
            <p className="mt-1 font-display text-lg font-bold tracking-tight text-[var(--brand)]">{GIFT_COPY.callToAction}</p>
            {/* Abre a página de avaliação do restaurante numa nova aba (no celular, normalmente o app do Google Maps),
                para esta tela continuar aberta e ser mostrada na saída. */}
            <a
              href={reviewUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                onReviewClick?.();
                setClicked(true);
              }}
              className="mt-4 inline-flex h-12 min-w-40 items-center justify-center gap-2 rounded-xl bg-[var(--brand)] px-6 font-semibold text-[var(--brand-contrast)] hover:brightness-95"
            >
              <Star className="size-4" /> {GIFT_COPY.button} <ExternalLink className="size-3.5" />
            </a>
            {thanks && <p role="status" className="mt-4 rounded-2xl bg-sprout-100 px-4 py-3 text-sm font-medium text-sprout-600">{thanksText}</p>}
          </>
        ) : (
          <p className="mt-2 text-sm text-ink-2">{GIFT_COPY.noReviewText}</p>
        )}
      </div>
    </section>
  );
}
